import { Link } from "react-router-dom";
import { stories } from "@/mocks/stories";

function formatDate(iso: string) {
  return iso.replace(/-/g, ".");
}

export default function Hero() {
  const hero = stories[0];
  const side = stories.filter((s) => s.kind === "要闻").slice(0, 3);

  return (
    <section className="border-b border-background-200 bg-gradient-to-b from-background-100/70 to-background-50">
      <div className="container-x py-8 md:py-12">
        {/* Masthead meta */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-2">
            <span className="inline-block h-3 w-3 rounded-full bg-primary-500" />
            {formatDate(new Date().toISOString().slice(0, 10))} · 每日吃瓜 · 第 238 期
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-sparkling-2-line text-accent-600" />
            今日已收录热门话题 26 个
          </span>
        </div>

        {/* Headline block */}
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-10">
          {/* Featured */}
          <div className="lg:col-span-8">
            <div className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200 md:aspect-[21/11]">
                <img
                  src={hero.cover}
                  alt={hero.coverAlt}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-background-950/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                    <i className="ri-fire-fill" /> 头版 · {hero.tag}
                  </span>
                  <h1 className="mt-3 max-w-2xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl md:leading-tight">
                    <Link to={`/story/${hero.slug}`} className="transition-opacity hover:opacity-90">
                      {hero.title}
                    </Link>
                  </h1>
                  <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-100/90 md:line-clamp-2">
                    {hero.lead}
                  </p>
                  <div className="mt-4 flex items-center gap-4 text-xs text-background-200">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-fire-line" /> {hero.heat}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line" /> 阅读约 {hero.readTime}
                    </span>
                    <Link
                      to={`/story/${hero.slug}`}
                      className="inline-flex items-center gap-1 font-bold text-accent-300 transition-colors hover:text-accent-200"
                    >
                      阅读全文 <i className="ri-arrow-right-line" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 今日速览 side */}
          <aside className="flex flex-col lg:col-span-4">
            <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-bard-line" /> 今日速览
            </p>
            <div className="flex flex-1 flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {side.map((s, i) => (
                <Link
                  key={s.slug}
                  to={`/story/${s.slug}`}
                  className="group flex flex-1 flex-col gap-1 p-4 transition-colors hover:bg-background-100/70 md:p-5"
                >
                  <span className="text-[11px] font-bold text-foreground-500">
                    {formatDate(s.date)} · {s.readTime}
                  </span>
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    {s.title}
                  </h3>
                  <span className="mt-auto inline-flex items-center gap-1 text-xs font-bold text-primary-600">
                    去围观 <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              ))}
            </div>
          </aside>
        </div>

        {/* Live strip */}
        <div className="mt-8 flex items-stretch gap-3 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="flex shrink-0 items-center gap-1.5 bg-primary-500 px-3 py-2 text-xs font-bold text-background-50 md:px-4">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50" />
            </span>
            <span className="hidden md:inline">实时吃瓜</span>
          </div>
          <div className="thin-scroll flex flex-1 items-center gap-2 overflow-x-auto px-2 py-2">
            {stories.map((s) => (
              <Link
                key={s.slug}
                to={`/story/${s.slug}`}
                className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:bg-primary-100/50 hover:text-primary-700"
              >
                <i className="ri-flashlight-fill text-accent-600" />
                {s.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}